import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface TpiGeneralizedIssuesState {
  TpiGeneralizedIssues: {
    load: boolean;
    data: [];
  };
}

export const TpiGeneralizedIssuesSlice = createSlice({
  name: "TpiGeneralizedIssues",
  initialState: {
    TpiGeneralizedIssues: {
      load: false,
      data: [],
    },
  } as TpiGeneralizedIssuesState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchTpiGeneralizedIssues.pending, (state: TpiGeneralizedIssuesState) => {
        state.TpiGeneralizedIssues.load = true;
      })
      .addCase(fetchTpiGeneralizedIssues.fulfilled, (state: TpiGeneralizedIssuesState, action: any) => {
        state.TpiGeneralizedIssues.data = action.payload;
        state.TpiGeneralizedIssues.load = false;
      })
      .addCase(fetchTpiGeneralizedIssues.rejected, (state: TpiGeneralizedIssuesState) => {
        state.TpiGeneralizedIssues.load = false;
      });
  },
});

export default TpiGeneralizedIssuesSlice.reducer;

export const fetchTpiGeneralizedIssues = createAsyncThunk(
  "TpiGeneralizedIssues/fetchTpiGeneralizedIssues",
  async (param: {apiParam: {project_pin: any, layout_id: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/getGenerelizedIssueData", {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id,
        page: 1,
        per_page: 1000
      });
      return data.data;
    } catch (error) {
    }
  }
);
